import React from "react"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"
import DealHighlight from "@irati/deals/constants/dealHighlightTypes"

import StyledIconText from "./styled/IconText"

const getText = (type: DealHighlight) => {
  switch (type) {
    case DealHighlight.COUPON:
    case DealHighlight.DIGITAL:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.digital" />
    case DealHighlight.PHYSICAL:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.physical" />
    case DealHighlight.INSTANT:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.instant" />
    case DealHighlight.ONE_HOUR:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.1hr" />
    case DealHighlight.COMPANY_BENEFIT:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.company" />
    case DealHighlight.APP_ONLY:
      return <FormattedMessage id="perks.dealHighlight.dealHighlightRow.appOnly" />
    case DealHighlight.TIME_LIMIT_24_HOUR:
      return <FormattedMessage id="perks.components.dealHighlight.dealHighlightRow.timeLimit24Hours" />
    default:
      return <span />
  }
}

interface Props {
  id?: string,
  size?: number,
  type: DealHighlight,
  isLabel?: boolean
}

const DealHighlightRow: React.FC<Props> = (props) => {
  const {type, size, isLabel} = props

  if (!type) {
    return null
  }

  const idNamespace = id("deal-highlight-row", props)

  return (
    <StyledIconText id={idNamespace} size={size} icon={type}>
      {isLabel && (
        <Label id={id("label", idNamespace)} color="contrast">
          {getText(type)}
        </Label>
      )}
    </StyledIconText>
  )
}

DealHighlightRow.defaultProps = {
  type: DealHighlight.ONE_HOUR,
  size: 16,
  isLabel: true
}

export default DealHighlightRow
